@use '@css/variables';

.section {

  background-color: var(--beige);
  //position: relative;

  ul {
    gap: 0;
  }

  &.white {
    background-color: white;
  }

  &.lighter {
    background-color: var(--beigelight);
  }

  &.light {
    background-color: var(--beige);
  }

  &.dark {
    background-color: var(--beigedark);
  }

  &.darker {
    background-color: var(--beigedarker);
  }

  &.hasCurl {
    position: relative;

    .container {
      position: relative;
    }

    .curl {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 5;
    }
  }

  &.hasInner {
    padding: 2em 1.5em;

    .container {
      max-width: 900px;
    }
  }

  .container {

    max-width: calc(900px + 3em);
    padding: 2em 1.5em;
    margin: 0 auto;

    z-index: 10;
    //position: relative;

    &.thin {
      padding-bottom: 0.5em;
    }

    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5em;
    }

    .content {
      width: 100%;

      .header {
        margin-bottom: 1.25em;
      }

      h1, h2, h3 {
        margin-bottom: .25em;
      }
    }

    .image {
      width: auto;
      height: 160px;
      flex-shrink: 0;
      justify-content: center;
      padding: 1em;
      display: flex;
      border-radius: var(--border-radius);
      flex-direction: column;

      img {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
      }

      &.coverImage {
        align-self: stretch;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: var(--border-radius);
        }
      }

      &.white {
        background-color: white;
      }

      &.lighter {
        background-color: var(--beigelight);
      }

      &.light {
        background-color: var(--beige);
      }

      &.dark {
        background-color: var(--beigedark);
      }

      &.darker {
        background-color: var(--beigedarker);
      }
    }

    &.whiteInner,
    &.lighterInner,
    &.lightInner,
    &.darkInner,
    &.darkerInner {

      border-radius: 1em;

      .content {
        padding: 1em;
      }

      &.bordered {
        border: 1px solid var(--beigedarker);
        border-radius: var(--border-radius);
        padding: 0;

        & > div {
          align-items: stretch;
        }

        .image {
          border-top: 1px solid var(--beigedarker);
          border-radius: 0 0 var(--border-radius) var(--border-radius);
        }
      }

      &.whiteInner {
        background-color: white;
      }

      &.lighterInner {
        background-color: var(--beigelight);
      }

      &.lightInner {
        background-color: var(--beige);
      }

      &.darkInner {
        background-color: var(--beigedark);
      }

      &.darkerInner {
        background-color: var(--beigedarker);
      }
    }

    &.center {
      text-align: center;
    }

    &.coverImageFlush {
      padding: 0;
      overflow: hidden;

      & > div {
        align-items: stretch;
      }

      .image {
        padding: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    // image cell fills the full row, flush to the panel edges, image stays contained
    &.stretchImage {
      padding: 0;
      overflow: hidden;

      & > div {
        align-items: stretch;
      }
    }
  }

  &.wide {
    .container {
      max-width: calc(1200px + 3em);
    }

    &.hasInner .container {
      max-width: 120px;
    }
  }

  &.fullWidth {
    .container {
      max-width: calc(100% + 3em);
    }

    &.hasInner .container {
      max-width: 100%;
    }
  }

  &.hasBackground {
    --section-background: var(--beige);
    position: relative;
    overflow: hidden;

    &.white {
      --section-background: white;
    }

    &.lighter {
      --section-background: var(--beigelight);
    }

    &.dark {
      --section-background: var(--beigedark);
    }

    &.darker {
      --section-background: var(--beigedarker);
    }

    .container {
      position: relative;
    }
  }

  // photo behind the section (right side from md), fading into the solid section background on the left
  .backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: right;
      opacity: 0.3;
      // closer to monochrome and shifted from peach towards the beige it fades into
      filter: saturate(0.5) hue-rotate(15deg);
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(to right, var(--section-background) 0%, color-mix(in srgb, var(--section-background) 40%, transparent) 25%, transparent 55%);
    }
  }
}

@media only screen and (min-width: variables.$sm-breakpoint) {
  .section {
    .container {
      & > div {
        flex-direction: row;
      }

      &.reverse > div {
        flex-direction: row-reverse;
      }

      .image {
        width: 220px;
        height: auto;

        &.highImage {
          height: 280px;
        }
      }

      &.bordered .image {
        border-left: 1px solid var(--beigedarker);
        border-top: 0 none !important;
        border-radius: 0 var(--border-radius) var(--border-radius) 0 !important;
      }

      // reversed layout: image sits on the left, so mirror the divider/radius to that side
      &.bordered.reverse .image {
        border-left: 0 none !important;
        border-right: 1px solid var(--beigedarker);
        border-radius: var(--border-radius) 0 0 var(--border-radius) !important;
      }
    }
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .section .backdrop {
    width: 60%;

    img {
      opacity: 1;
    }
  }
}

@media only screen and (min-width: variables.$lg-breakpoint) {
  .section .backdrop {
    width: 50%;
  }
}

.curl {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 5;
}
